export default {
  collapseOrderHeader: false,
  collapsePromo: false,
  collapseB2BPromo: false,
  allowOrderEdit: true,
  enableQuotes: true,
  hideCreateNew: false,
  hideCreateNewShipTo: false,
  hideCreateNewContact: false,
  hideCreateNewCustomer: false,
  hideShopViewTab: false,
  hideCatalogsTab: false,
  hideInvoicesTab: false,
  hideSplitOrder: false,
  hideExportBox: true,
  hideAllowBackOrders: true,
  hideShipComplete: true,
  hideRepFax: true,
  hideLocation: true,
  hideReExport: true,
  hideReasonCode: true,
  hideRepReasonCode: true,
  //cancelDateDays: 120,
  shipDateDays: 0,
  hidePrintWithBarcodes: false,
  hidePrintWithInlineImages: true,
  emailOrderDefaultReplyTo: true,
  allowResendApprovalRequest: false,
  allowResendPaymentRequest: true,
  showBulkActions: true,
  useNewCatalog: false,
  showOrderNotes: false,
  useVendorDropDown: false,
  hideDetailNavTabs: false,
  hideDetailTopNav: false,
  hideMultiAddConfigMessage: false,
  hideMetaInHeader: false,
  useCustomerCreditHoldOrderLogic: true,
  defaultRetailerDiscount: false,
  ExportOpenLinesQuickReportName: "ExportOpenLinesByOrderNumber",
  ExportShippedLinesQuickReportName: "ExportShippedLinesByOrderNumber",
  filters: [
    // { hidden: "RetailerId" },
    { hidden: "DateRange" },
    { groupBy: "Status", title: "EmunStatus" },
    { groupBy: "ErpStatus", title: "ERP Status" },
    { groupBy: "SourceId", title: "Source" },
    { text: "LineProductId", title: "Product #", collapsed: true },
    { date: "OrderedOn", title: "Order Date" },
    {
      groupBy: "CurrentRepName",
      title: "Rep of Record",
      roles: [
        "Administrator",
        "Sales Manager",
        "Manager",
        "Web Admin",
        "Corporate",
      ],
    },
    {
      groupBy: "WritingRepName",
      title: "Writing Rep",
      collapsed: true,
      //roles: ["Administrator", "Sales Manager", "Web Admin", "Corporate"],
      authorize: (s) => s.isManagerOrAbove() || s.showMode,
    },
    { date: "ShipOn", title: "Ship Date" },
    { number: "GrandTotal", title: "Amount" },
    { groupBy: "ShowCodeName", title: "Show Code" },
    { groupBy: "Type" },
  ],
  routes: [
    { name: "lines", title: "Line Items", icon: "shopping-cart" },
    //removing these because they are now in the top nav
    // { name: "shop", title: "Shop", icon: "search" },
    // { name: "catalogs", title: "Catalogs", icon: "file" },
    { name: "invoices", title: "Invoices", icon: "usd" },
  ],
  defaultDetailRoute: "orders.detail.lines",
  getFirstDetailRoute: ($cart, $state, base) =>
    $state.getNav(base + ".detail")[0],
  statusCss(status,reason) {
    switch ((status || "").replace(/\W/gi, "").toLowerCase()) {
      case "cart":
        return "label-warning";
      case "inprogress":
      case "open":
        return "label-success";
      case "complete":
      case "completed":
      case "closed":
        return "label-info bg-color-1";
      case "cancel":
      case "cancelled":
      case "onhold":
      case "deleted":
        return "label-danger";
      case "partiallyshipped":
        return "label-warning";
      case "review":
        return (reason || "").replace(/\W/gi, "").toLowerCase().indexOf("vendor") >= 0 ? "label-default" : "label-danger";
      case "shipped":
        return "bg-color-4";
    }
    return "label-default";
  },
  stageCss(stage) {
    switch ((stage || "").replace(/\W/gi, "").toLowerCase()) {
      case "emun":
        return "info";
      case "transferred":
        return "warning";
    }
    return "default hide hidden";
  },
  availableDeliveryTypes: [],
  showLineTotals: false,
  MultiAddDefaultProductMinimum: false,
  limitVendorByRepGroup: false,
  startOrderMinInfo: false,
  termChangeNewCustomerOnly: false,
  maxChangeAmount: 999999999,
  showSources: [],
  reviewReasons: ["New Customer", "New Location"],
  showAllCartsForRetailers: false,
  showOrderExportQuickReport: true,
  OrderExportQuickReportName: "ExportLinesByOrderNumber",
  OrdersExportQuickReportName: "ExportLinesByOrderNumbers",
  orderShowroomDateRangeSearch: "Today",
  orderDefaultDateRangeSearch: "All",
  orderCustDefaultDateRangeSearch: "All",
  orderVendorDateRangeSearch: "Last365",
  defaultShowCodeFilter: true,
  hideDeletePartsOrder: true,
  hideParcels: false,
  retailerSearchFields: "Id,CompanyName,Address,City,State,Zip,Country,Phone,Status,PORequired,IsCreditHold,IsNewAccount,PaymentTerms,ShippingMethod,PriceList,Email,DefaultShipOn,Discount,Notes"
};
